import { render, staticRenderFns } from "./WorkoutEditForm.vue?vue&type=template&id=4a874590"
import script from "./WorkoutEditForm.vue?vue&type=script&lang=js"
export * from "./WorkoutEditForm.vue?vue&type=script&lang=js"
import style0 from "./WorkoutEditForm.vue?vue&type=style&index=0&id=4a874590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports